import { injectable } from "inversify";
import { rootContainer, TYPE } from "../container/root";
import { IApiResponse, IHttpService } from "../http-service";
import {WithOld} from "../../stores/types";

export enum BCC_RECEIVER_ENUM {
    NONE = 'none',
    MERCHANT = 'merchant',
    CUSTOMER = 'customer',
    BOTH = 'both'
}
export interface IEmailSetting {
    bcc_owner: boolean;
    bcc_email: string;
    shipment_status_in_transit_update: BCC_RECEIVER_ENUM;
    shipment_status_shipment_received_update: BCC_RECEIVER_ENUM;
}


@injectable()
class EmailSettingService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getEmailSetting(): Promise<IEmailSetting> {
        const res = await this.httpService.get<IApiResponse<IEmailSetting>>(`/rms-api/email/setting`);
        return res.payload;
    }
    
    async updateEmailSetting(data: WithOld<IEmailSetting>): Promise<IEmailSetting> {
        const res = await this.httpService.put<IApiResponse<IEmailSetting>>(`/rms-api/email/setting`, data);
        return res.payload;
    }
}

export default EmailSettingService;
